import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import axiosInstance from "./plugins/axios";
import Vue2Editor from "vue2-editor";

Vue.use(Vue2Editor);

let app;

Vue.config.productionTip = false;
Vue.prototype.$axios = axiosInstance;
import store from "./store";
store.dispatch("initializeUser");
import router from "./router";
app = new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
});

app.$mount("#app");
